import { render, staticRenderFns } from "./Edm.vue?vue&type=template&id=f0cd3cc6&scoped=true&"
import script from "./Edm.vue?vue&type=script&lang=js&"
export * from "./Edm.vue?vue&type=script&lang=js&"
import style0 from "./Edm.vue?vue&type=style&index=0&id=f0cd3cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cd3cc6",
  null
  
)

export default component.exports